export const WhatsAppIcon = ({ className = "h-5 w-5" }) => (
    <svg viewBox="0 0 682 682.667" className={className} aria-hidden="true">
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M544.387 93.008C484.512 33.063 404.883.035 320.05 0 145.246 0 2.98 142.262 2.91 317.113c-.024 55.895 14.577 110.457 42.331 158.551L.25 640l168.121-44.102c46.324 25.27 98.477 38.586 151.55 38.602h.134c174.785 0 317.066-142.273 317.132-317.133.036-84.742-32.921-164.418-92.8-224.36zM320.05 580.94h-.11c-47.296-.02-93.683-12.73-134.16-36.742l-9.62-5.715-99.766 26.172 26.628-97.27-6.27-9.972c-26.386-41.969-40.32-90.476-40.296-140.281.055-145.332 118.305-263.57 263.7-263.57 70.406.023 136.59 27.476 186.355 77.3s77.156 116.051 77.133 186.485C583.582 462.69 465.34 580.94 320.05 580.94m144.586-197.418c-7.922-3.968-46.883-23.132-54.149-25.78-7.258-2.645-12.547-3.962-17.824 3.968-5.285 7.93-20.469 25.781-25.094 31.066-4.625 5.29-9.242 5.953-17.168 1.985-7.925-3.965-33.457-12.336-63.726-39.332-23.555-21.012-39.457-46.961-44.082-54.89-4.617-7.938-.04-11.813 3.476-16.173 8.578-10.652 17.168-21.82 19.809-27.105 2.644-5.29 1.32-9.918-.664-13.883-1.977-3.965-17.824-42.969-24.426-58.84-6.437-15.445-12.965-13.36-17.832-13.601-4.617-.231-9.902-.278-15.187-.278-5.282 0-13.868 1.98-21.133 9.918-7.262 7.934-27.73 27.102-27.73 66.106s28.394 76.683 32.355 81.972c3.96 5.29 55.879 85.328 135.367 119.649 18.906 8.172 33.664 13.043 45.176 16.695 18.984 6.031 36.254 5.18 49.91 3.14 15.226-2.277 46.879-19.171 53.488-37.68 6.602-18.51 6.602-34.374 4.617-37.683-1.976-3.304-7.261-5.285-15.183-9.254"
        />
    </svg>
);

export const LogoMark = ({ className = "h-9 w-9" }) => (
    <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
        <rect width="64" height="64" rx="14" fill="#1A6AFF" />
        <path
            d="M32 12c-9.4 0-15.7 6.8-15.7 16.6 0 6.8 2.9 10.4 4.4 16.3 1.3 4.9 4.9 5.4 6.2.5 1.1-4.1 1.8-8.3 5.1-8.3s4 4.2 5.1 8.3c1.3 4.9 4.9 4.4 6.2-.5 1.5-5.9 4.4-9.5 4.4-16.3C47.7 18.8 41.4 12 32 12Z"
            fill="#fff"
        />
        <circle cx="45" cy="45" r="11" fill="#fff" />
        <path
            d="M45 40v10M40 45h10"
            stroke="#1A6AFF"
            strokeWidth="3.4"
            strokeLinecap="round"
        />
    </svg>
);

export const LogoFull = ({ dark = false }) => (
    <span className="flex items-center gap-3" data-testid="site-logo">
        <LogoMark className="h-10 w-10 shrink-0" />
        <span className="flex flex-col leading-none">
            <span
                className={`font-heading text-[17px] font-extrabold tracking-tight ${
                    dark ? "text-white" : "text-slate-900"
                }`}
            >
                Dr. Gabriel Riccio
            </span>
            <span className="mt-1 text-[10px] font-bold uppercase tracking-[0.28em] text-[#1A6AFF]">
                Endodontista
            </span>
        </span>
    </span>
);
